import keycodes from '../keycodes';

export default function createEnterKeyHandler(fn) {
  return (e) => {
    if (e.keyCode === keycodes.ENTER) {
      fn(e);
    }
  };
}
